export default __webpack_public_path__ + "static/media/qatar.b522e073.svg";